import type { ExcelGridSortIconProps } from "../models/excel-grid-component-props.models";
import { ArrowsUpDownIcon, ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";

export const ExcelGridSortIcon = ({ direction }: ExcelGridSortIconProps) => {
  if (direction === "asc") {
    return <ChevronUpIcon className="h-3.5 w-3.5 flex-none" />;
  }

  if (direction === "desc") {
    return <ChevronDownIcon className="h-3.5 w-3.5 flex-none" />;
  }

  return <ArrowsUpDownIcon className="h-3.5 w-3.5 flex-none opacity-40" />;
};
